import React from "react";
import { motion } from "framer-motion";
import { PartyPopper, Heart, Sparkles } from "lucide-react";
import { Confetti } from "./Confetti";

export const FinalSlide = () => {
  return (
    <div className="slide-content" data-testid="final-slide">
      <Confetti count={140} />
      <div className="max-w-4xl w-full text-center px-4 relative z-10">
        <motion.div
          initial={{ scale: 0, rotate: -30 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: "spring", stiffness: 110, damping: 10 }}
          className="text-7xl sm:text-8xl mb-2"
        >
          🎉
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="font-heading font-bold text-4xl sm:text-6xl text-slate-900 leading-tight"
        >
          <span style={{ color: "#FB923C" }}>Congratulations!</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="font-heading text-xl sm:text-3xl text-slate-800 mt-4"
        >
          You have explored all <span style={{ color: "#2563EB" }}>Seven Wonders of the World!</span> 🌍✨
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          className="glass-card p-6 sm:p-8 mt-8 inline-block"
        >
          <div className="flex items-center justify-center gap-2 mb-2">
            <Sparkles className="w-5 h-5 text-amber-500" />
            <span className="font-accent text-sm uppercase tracking-wider text-slate-600 font-semibold">
              Class Question
            </span>
            <Sparkles className="w-5 h-5 text-amber-500" />
          </div>
          <p className="font-heading text-xl sm:text-2xl text-slate-900 max-w-2xl">
            Which wonder would <span style={{ color: "#FB923C" }}>YOU</span> like to visit someday? 🗺️
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9 }}
          className="mt-10"
        >
          <h3 className="font-heading font-bold text-3xl sm:text-4xl text-slate-900 flex items-center justify-center gap-2">
            <Heart className="w-7 h-7 text-rose-500 fill-rose-500" /> Thank You!
          </h3>
          <p className="font-body text-base text-slate-700 mt-3">
            Presented by <strong className="font-heading">Yzabelle</strong>
            <br />
            For <strong className="font-heading">Ms. Sutherland</strong>
            <br />
            Grade 3 Class
          </p>

          <div className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-amber-100 border-2 border-amber-300">
            <PartyPopper className="w-4 h-4 text-amber-600" />
            <span className="font-heading font-bold text-amber-800 text-sm">
              The End - Hope you enjoyed the journey!
            </span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
